import React from "react";
import Link from "next/link";
import styles from "./SitemapLinkList.module.scss";

/**
 * Multi-column list of internal links, shared by the sitemap hub and its section
 * pages. CSS multi-column is the right primitive for a sorted list: it reads
 * top-to-bottom per column and needs no JS chunking, so the markup stays a
 * single flat <ul> that a crawler walks in order.
 *
 * `items` are `{ label, value }` where every `value` is an absolute path — see
 * the leading-slash note in utils/sitemapData.js.
 */
const SitemapLinkList = ({ items = [], columns = 4 }) => {
  if (!items.length) return null;

  return (
    <ul className={`${styles.list} ${styles[`cols${columns}`] ?? ""}`}>
      {items.map((item) => (
        <li key={item.value} className={styles.item}>
          <Link href={item.value} className={styles.link}>
            {item.label || item.value}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SitemapLinkList;
